/**
 * Auth Pages - Random Background Image
 * Sélectionne une image aléatoire parmi une liste d'images de campus au chargement
 */

// Liste des images de campus disponibles
const AUTH_CAMPUS_IMAGES = [
  'https://cdn.u-picardie.fr/ds-upjv/assets/img/campus/campus-beauvais.jpg',
  'https://cdn.u-picardie.fr/ds-upjv/assets/img/campus/campus-cathedrale.jpg',
  'https://cdn.u-picardie.fr/ds-upjv/assets/img/campus/campus-citadelle.jpg',
  'https://cdn.u-picardie.fr/ds-upjv/assets/img/campus/campus-creil.jpg',
  'https://cdn.u-picardie.fr/ds-upjv/assets/img/campus/campus-laon.jpg',
  'https://cdn.u-picardie.fr/ds-upjv/assets/img/campus/campus-st-charles.jpg',
  'https://cdn.u-picardie.fr/ds-upjv/assets/img/campus/campus-st-leu.jpg',
  'https://cdn.u-picardie.fr/ds-upjv/assets/img/campus/campus-st-quentin.jpg',
  'https://cdn.u-picardie.fr/ds-upjv/assets/img/campus/campus-sud.jpg',
  'https://cdn.u-picardie.fr/ds-upjv/assets/img/campus/campus-teinturie.jpg',
  'https://cdn.u-picardie.fr/ds-upjv/assets/img/campus/campus-thil.jpg'
];

/**
 * Initialise les images aléatoires pour les pages d'authentification split
 * @param {HTMLElement} container - Conteneur pour limiter la portée (default: document)
 */
export function initAuthRandomImage(container = document) {
  // Sélectionner tous les éléments avec la classe .auth-page__image--random-campus
  const imageElements = container.querySelectorAll('.auth-page__image--random-campus');

  imageElements.forEach((element) => {
    // Éviter la double initialisation par élément
    if (element.dataset.authRandomImageInit) return;
    element.dataset.authRandomImageInit = 'true';

    const randomIndex = Math.floor(Math.random() * AUTH_CAMPUS_IMAGES.length);
    const randomImage = AUTH_CAMPUS_IMAGES[randomIndex];
    element.style.backgroundImage = `url('${randomImage}')`;
  });
}

// Auto-init au chargement du DOM
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAuthRandomImage());
  } else {
    initAuthRandomImage();
  }
}
